import React from "react";

const SongCard = ({ paper, image, title, year, desc, extraClass }) => {
  return (

    <div className={`songCardOuter ${extraClass}`}>

      <img src={paper} className="songCardPaper" />

      <div className="songCardInner">

        <img src={image} className="songImage" />

        <div className="songInfoBox">
          <h3 className="songName">{title}</h3>
        </div>

        <h4 className="songYear">{year}</h4>

        <p className="songDesc">
          {desc}
        </p>

      </div>

    </div>

  );
};

export default SongCard;